export const servicesTranslations = {
  fr: {
    hero: {
      title: 'Mes accompagnements',
      subtitle: 'Des accompagnements personnalisés pour votre bien-être et votre épanouissement',
      intro1: 'Des accompagnements personnalisés pour mieux comprendre votre fonctionnement, retrouver de la clarté et avancer avec confiance.',
      intro2: 'Plus de 20 ans d\'accompagnement dans le développement personnel, les relations familiales et la connaissance de soi.'
    },
    
    services: {
      mostRequested: 'Le plus demandé',
      numerology: {
        title: 'Thème numérologique complet',
        price: '140 €',
        duration: '2h',
        description: 'Une étude approfondie de votre personnalité, de vos potentiels, de vos défis de vie et de vos cycles actuels.',
        benefit: 'Vous repartez avec une meilleure compréhension de vous-même et des clés concrètes pour avancer dans votre vie personnelle ou professionnelle.'
      },
      coaching: {
        title: 'Conseils personnels',
        price: '80 €',
        duration: '1h',
        description: 'Un accompagnement personnalisé pour faire le point sur une situation précise, retrouver de la clarté et prendre des décisions plus sereinement.',
        benefit: 'Idéal lors d\'une période de transition, de doute ou de questionnement.'
      },
      therapy: {
        title: 'Accompagnement de couple et familial',
        priceIndividual: '80 € individuel (1h)',
        priceCouple: '100 € couple (1h30)',
        duration: '1h à 1h30',
        description: 'Mieux comprendre les mécanismes relationnels, améliorer la communication et retrouver un équilibre plus serein au sein du couple ou de la famille.',
        benefit: 'Un espace d\'écoute bienveillant pour avancer ensemble.'
      },
      energy: {
        title: 'Accompagnement énergétique',
        price: '80 €',
        duration: '1h',
        description: 'Libération émotionnelle, harmonisation énergétique, recentrage et travail sur les blocages qui freinent votre évolution.',
        benefit: 'Une approche complémentaire pour retrouver davantage de sérénité et d\'alignement.'
      },
      button: 'Prendre rendez-vous'
    },
    
    whyConsult: {
      title: 'Pourquoi me consulter ?',
      reason1: 'Plus de 20 ans d\'expérience dans l\'accompagnement humain',
      reason2: 'Consultations en français ou en espagnol',
      reason3: 'En présentiel à Ibiza ou à distance partout dans le monde',
      reason4: 'Approche personnalisée et bienveillante',
      reason5: 'Accompagnement centré sur des solutions concrètes'
    },
    
    testimonials: {
      title: 'Témoignages',
      subtitle: 'Ils m\'ont fait confiance',
      testimonial1: {
        text: 'Une séance qui m\'a permis de comprendre des schémas que je répétais depuis des années.',
        author: 'Sophie, France'
      },
      testimonial2: {
        text: 'Une approche douce, claire et très professionnelle.',
        author: 'Marie, Belgique'
      },
      testimonial3: {
        text: 'La numérologie m\'a apporté des réponses concrètes et une meilleure compréhension de moi-même.',
        author: 'Isabelle, Suisse'
      }
    },
    
    cta: {
      title: 'Vous souhaitez faire le point sur votre situation ?',
      subtitle: 'Réservez un appel découverte gratuit de 30 minutes. Nous échangerons ensemble afin d\'identifier l\'accompagnement le plus adapté à vos besoins.',
      button: 'Prendre rendez-vous pour un appel découverte gratuit'
    }
  },
  
  es: {
    hero: {
      title: 'Mis acompañamientos',
      subtitle: 'Acompañamientos personalizados para tu bienestar y tu desarrollo',
      intro1: 'Acompañamientos personalizados para comprender mejor tu funcionamiento, recuperar la claridad y avanzar con confianza.',
      intro2: 'Más de 20 años de acompañamiento en desarrollo personal, relaciones familiares y conocimiento de uno mismo.'
    },
    
    services: {
      mostRequested: 'El más solicitado',
      numerology: {
        title: 'Tema numerológico completo',
        price: '140 €',
        duration: '2h',
        description: 'Un estudio en profundidad de tu personalidad, tus potenciales, tus desafíos de vida y tus ciclos actuales.',
        benefit: 'Te vas con una mejor comprensión de ti mism@ y claves concretas para avanzar en tu vida personal o profesional.'
      },
      coaching: {
        title: 'Asesoramiento personal',
        price: '80 €',
        duration: '1h',
        description: 'Un acompañamiento personalizado para hacer balance de una situación precisa, recuperar la claridad y tomar decisiones con más serenidad.',
        benefit: 'Ideal durante un período de transición, duda o cuestionamiento.'
      },
      therapy: {
        title: 'Acompañamiento de pareja y familiar',
        priceIndividual: '80 € individual (1h)',
        priceCouple: '100 € pareja (1h30)',
        duration: '1h a 1h30',
        description: 'Comprender mejor los mecanismos relacionales, mejorar la comunicación y recuperar un equilibrio más sereno en la pareja o la familia.',
        benefit: 'Un espacio de escucha afectuoso para avanzar juntos.'
      },
      energy: {
        title: 'Acompañamiento energético',
        price: '80 €',
        duration: '1h',
        description: 'Liberación emocional, armonización energética, recentrado y trabajo sobre los bloqueos que frenan tu evolución.',
        benefit: 'Un enfoque complementario para recuperar más serenidad y alineación.'
      },
      button: 'Reservar cita'
    },
    
    whyConsult: {
      title: '¿Por qué consultarme?',
      reason1: 'Más de 20 años de experiencia en acompañamiento humano',
      reason2: 'Consultas en francés o en español',
      reason3: 'Presencial en Ibiza o a distancia en todo el mundo',
      reason4: 'Enfoque personalizado y afectuoso',
      reason5: 'Acompañamiento centrado en soluciones concretas'
    },
    
    testimonials: {
      title: 'Testimonios',
      subtitle: 'Han confiado en mí',
      testimonial1: {
        text: 'Una sesión que me permitió comprender patrones que repetía desde hace años.',
        author: 'Sophie, Francia'
      },
      testimonial2: {
        text: 'Un enfoque suave, claro y muy profesional.',
        author: 'Marie, Bélgica'
      },
      testimonial3: {
        text: 'La numerología me aportó respuestas concretas y una mejor comprensión de mí misma.',
        author: 'Isabelle, Suiza'
      }
    },
    
    cta: {
      title: '¿Quieres hacer un balance de tu situación?',
      subtitle: 'Reserva una llamada descubrimiento gratuita de 30 minutos. Hablaremos juntos para identificar el acompañamiento más adecuado a tus necesidades.',
      button: 'Reservar llamada gratuita'
    }
  }
};
